import { render, staticRenderFns } from "./completion.vue?vue&type=template&id=746196fa&scoped=true&"
import script from "./completion.vue?vue&type=script&lang=js&"
export * from "./completion.vue?vue&type=script&lang=js&"
import style0 from "./completion.vue?vue&type=style&index=0&id=746196fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746196fa",
  null
  
)

export default component.exports